module.exports = __webpack_public_path__ + "img/logo-login.31610d47.png";